import type { HexColor, ColorFunction, RelativeColorFunction, LightDark } from '@wix/thunderbolt-becky-root'
import { getConverter } from '../../utils/convertersRegistry'
import { getStringFromConverter, getKeywordString } from '../../utils/converterHelpers'
import type { StylePropertiesTypes } from '@wix/document-services-types'

/** Internal Converters */
const hexColorConverter = (prop: HexColor): string => {
	return `${prop.value}`
}

const mapColorValues = (values: ColorFunction['values'] | RelativeColorFunction['values']) =>
	values
		.map((value) => {
			const converter = getConverter(value.type)
			return converter ? getStringFromConverter(converter(value)) : ''
		})
		.join(' ')

const colorFunctionConverter = (prop: ColorFunction): string => {
	let alpha = ''
	if (prop.alpha) {
		const alphaConverter = getConverter(prop.alpha.type)
		alpha = alphaConverter ? ` / ${getStringFromConverter(alphaConverter(prop.alpha))}` : ''
	}

	return `${prop.function}(${mapColorValues(prop.values)}${alpha})`
}

const relativeColorFunctionConverter = (prop: RelativeColorFunction): string => {
	let alpha = ''
	if (prop.alpha) {
		const alphaConverter = getConverter(prop.alpha.type)
		alpha = alphaConverter ? ` / ${getStringFromConverter(alphaConverter(prop.alpha))}` : ''
	}

	const fromColorConverter = getConverter(prop.from.type)
	const fromColor = fromColorConverter ? getStringFromConverter(fromColorConverter(prop.from)) : ''

	return `${prop.function}(from ${fromColor} ${mapColorValues(prop.values)}${alpha})`
}

const lightDarkConverter = (prop: LightDark): string => {
	const lightConverter = getConverter(prop.light.type)
	const light = lightConverter ? getStringFromConverter(lightConverter(prop.light)) : ''

	const darkConverter = getConverter(prop.dark.type)
	const dark = darkConverter ? getStringFromConverter(darkConverter(prop.dark)) : ''

	return `light-dark(${light}, ${dark})`
}

/** External Mapper */
export const colorConverterMap = {
	HexColor: hexColorConverter,
	ColorFunction: colorFunctionConverter,
	RelativeColorFunction: relativeColorFunctionConverter,
	LightDark: lightDarkConverter,
	Keyword: getKeywordString, // KeywordColor support
} as Record<string, (prop: StylePropertiesTypes.Color) => string>
